import { makeAutoObservable } from "mobx";
import { ParameterScope } from "../ParameterScope";
/*
  Parametrized modifier instance editability class to optimize unification - calculated once for all ModifierItemInstances
*/
export class ModifierInstanceEditability {
    constructor(editabilityParametrization) {
        this.scope = ParameterScope.Uninitialized;
        this.editabilityParametrization = editabilityParametrization;
        makeAutoObservable(this);
    }
    setScope(scope) {
        this.scope = scope;
    }
    get isEditable() {
        return this.editabilityParametrization.unify(this.scope.parameterSet);
    }
    get isPossiblyEditable() {
        return this.isEditable.isValuePossible(true);
    }
    clone() {
        return new ModifierInstanceEditability(this.editabilityParametrization);
    }
}
